import * as React from 'react';

import PrimaryButton from './PrimaryButton';
import SecondaryButton from './SecondaryButton';
import AlertButton from './AlertButton';
import { IButtonProps } from './common';

const Button: React.FunctionComponent<IButtonProps> = props => {
  switch (props.buttonStyle) {
    case 'secondary':
      return <SecondaryButton {...props} />;
    case 'alert':
      return <AlertButton {...props} />;
    case 'primary':
    default: // this should match DEFAULT_BUTTON_STYLE
      return <PrimaryButton {...props} />;
  }
};

Button.displayName = 'Button';

export default Button;
